// gen
// const baseUrl = "http://fangke.tulangbao.com/index";
const baseUrl = "http://ytmf.ubooking.cn/index";
// dev
// const baseUrl = "http://ytmf.liuyunchuan.com/index";

export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js